module.exports = __webpack_public_path__ + "static/media/landscape2.7442b624.jpg";